import $ from 'jquery';

class profileOverlay {

  constructor() {
    this.openButton = $(".teamGrid__card");
    this.closeButton = $("a.teamGrid__close");
    this.profileOverlay = $(".teamGrid__details-wrapper");
    this.isOverlayOpen = false;
    this.events();
    this.body = $('body');
  }

  events() {
    this.openButton.on("click", this.openProfileOverlay.bind(this));
    $(document).on("keydown", this.keyPressDispatcher.bind(this));
    $(document).on("click", ".teamGrid__close", this.closeProfileOverlay.bind(this));
    //$(window).on("click", this.closeProfileOverlay.bind(this));
  }

  openProfileOverlay(e) {
    let target = e.currentTarget;
    target = target.getAttribute('data-href');
    target = target.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''); 
    let contents = $('#' + target).html();

    if (this.profileOverlay.attr('data-target', target)) {
      this.body.prepend(`<div class="teamGrid__overlay-mask"></div><div class="teamGrid__details-wrapper opened">${contents}</div>`);
      this.body.addClass("body-no-scroll");
      this.isOverlayOpen = true;
    }
  }

  closeProfileOverlay() {
    this.isOverlayOpen = false;
    $('.opened, .teamGrid__overlay-mask').fadeOut(200);
    //$('.teamGrid__details-wrapper.opened').addClass('closing');
    setTimeout(function() {
      $('.opened, .teamGrid__overlay-mask').remove();
      $('body').removeClass("body-no-scroll");
    }, 0);
  }

  // closePanel(e) {
  //   if ($(this)) {
  //     if ($(".teamGrid__details-wrapper").has(e.target).length == 0 && !$(".teamGrid__details-wrapper").is(e.target)) {
  //       $('.opened').remove();
  //       $('body').removeClass("body-no-scroll");
  //     }
  //   }
  // }

  keyPressDispatcher(e) {
    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeProfileOverlay();
    }
  }

}

export default profileOverlay;